import { Fragment, useMemo, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
// import Slider from "react-slick";
import { useAuth } from "../../utils/auth";
import { sdkWrapperURL } from "../../utils/api-url-list";
// import FaceScan from "../assets/images/FaceScan.webp";
// import FingerScan from "../assets/images/FingerScan.webp";
import InstructionFaceScan1 from "../../assets/images/instructions/face1.webp";
import InstructionFaceScan2 from "../../assets/images/instructions/face2.webp";
import InstructionFaceScan3 from "../../assets/images/instructions/face3.webp";
import InstructionFaceFingerScan from "../../assets/images/instructions/face-finger.webp";
import InstructionFingerScan1 from "../../assets/images/instructions/finger1.webp";
import InstructionFingerScan2 from "../../assets/images/instructions/finger2.webp";
import { ReactComponent as Loader } from "../../assets/icons/Loader.svg";
import BackArrow from "../../assets/images/back-arrow.svg";
import FaceScanImg from "../../assets/images/face-scan-img.png";

const VitalsScanInstructions = () => {
  const {
    getToken,
    userData: { user_id, profile_id },
  } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const scanType = "face";
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const startScan = async () => {
    try {
      window?.ReactNativeWebView?.postMessage?.("prompt-camera-permission");
      setLoading(true);
      const token = await getToken();
      const scanTokenResp = await fetch(
        sdkWrapperURL("/users/sdk/test_api_private"),
        {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: token },
          body: JSON.stringify({
            action: "create_scan_UL",
            employee_id: user_id,
            profile_id: profile_id,
          }),
        }
      );
      const scanTokenRespJSON = await scanTokenResp.json();
      if (scanTokenRespJSON?.statusCode?.toString().startsWith("2"))
        navigate(`/vitals-derma-face-scan`, {
          state: {
            ...state,
            scanToken: scanTokenRespJSON.scan_token,
            scanTokenExpiry: new Date(
              scanTokenRespJSON.token_expiry?.replace(" ", "T")
            ).getTime(),
          },
        });
      else
        throw new Error(
          scanTokenRespJSON?.message ?? "Error in Fetching the Scan Token"
        );
    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const instructions = useMemo(
    () =>
      ({
        face: [
          {
            img: InstructionFaceScan1,
            desc: "The ambient light should be bright, consistent, and white.",
          },
          {
            img: InstructionFaceScan2,
            desc: "Remove any face-obstructing items, such as your mask, eyewear, or clothing.",
          },
          {
            img: InstructionFaceScan3,
            desc: "Keep your face and phone steady to avoid movements during the scan.",
          },
          {
            img: InstructionFaceFingerScan,
            desc: "If prompted, allow the camera permission.",
          },
        ],
        finger: [
          {
            img: InstructionFingerScan1,
            desc: "Place your finger on the rear primary camera and the flashlight.",
          },
          {
            img: InstructionFingerScan2,
            desc: "If the flash is not turned on then place some light behind the phone.",
          },
          {
            img: InstructionFaceFingerScan,
            desc: "If prompted, allow the camera permission.",
          },
        ],
      }[scanType] ?? []),
    [scanType]
  );
  const settings = {
    dots: true,
    lazyLoad: true,
    infinite: true,
    speed: 850,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    Arrow: false,
    autoplaySpeed: 2500,
    pauseOnDotsHover: false,
  };

  return scanType === "face" || scanType === "finger" ? (
    <section className="px-6 pt-2 pb-24 relative tab-screen">
      <div className="flex items-center justify-center relative mb-8 xl:justify-start">
        <Link
          to={-1}
          className=" w-9 h-9 bg-[#2D2D2D] rounded-full absolute left-0 flex flex-row justify-center items-center"
        >
          <img src={BackArrow} alt="" />
        </Link>
        <h2 className="text-xl font-medium text-white lg:text-2xl md:text-2xl xl:ml-14">
          Instructions
        </h2>
      </div>
      <div className="flex flex-col items-center justify-center relative z-50">
        <img src={FaceScanImg} className="w-28 mb-3" alt="" />
        <div className=" bg-[#1D1D1D]/70 rounded-[20px] w-11/12 lg:w-8/12 md:w-8/12 m-auto p-6 lg:mt-6 md:mt-6">
          <h6 className=" text-base font-semibold text-secondary mb-3">
            Face Scan
          </h6>
          <div className="ml-0">
            <ol
              type="1"
              className="list-outside list-item text-xxs text-white font-light p-0 m-0"
            >
              <li className="mb-3 flex flex-row">
                <span className="mr-[2px]">1.</span> The ambient light should be
                bright and consistent and must be white.
              </li>
              <li className="text-xxs text-white font-light mb-3 flex flex-row">
                <span className="mr-[2px]">2.</span>Remove your masks, eye-wear,
                or clothing obstruction the face for the duration of scan.
              </li>
              <li className="text-xxs text-white font-light mb-3 flex flex-row">
                <span className="mr-[2px]">3.</span>Keep your face and phone
                steady to avoid movements during the scan.
              </li>
              <li className="text-xxs text-white font-light mb-3 flex flex-row">
                <span className="mr-[2px]">4.</span>For light mode: Make sure
                your face is mostly covered by the blue circle.
              </li>
              <li className="text-xxs text-white font-light mb-3 flex flex-row">
                <span className="mr-[2px]">5.</span>If prompted, allow the
                camera.
              </li>
            </ol>
          </div>
          <button
            className="mt-6 w-full flex items-center font-medium justify-center space-x-4 rounded-full outline-none px-5 py-2.5 bg-white disabled:bg-none disabled:bg-darkgray text-black mb-2"
            type="button"
            onClick={startScan}
            disabled={loading}
          >
            <span>Proceed</span>
            {loading && <Loader className="flex-shrink-0 h-4 w-4" />}
          </button>
        </div>
      </div>
      <div className="circle-blur w-[70%] h-56 mx-auto absolute top-24 left-0 right-0 blur-[100px]"></div>

      <Transition show={error.length > 0} as={Fragment}>
        <Dialog as={Fragment} onClose={() => {}}>
          <Transition.Child
            className="fixed top-0 bottom-0 left-0 right-0 bg-black/70 flex items-center justify-center"
            enter="duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="duration-300 delay-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Transition.Child
              as={Fragment}
              enter="delay-150 duration-200"
              enterFrom="opacity-0 scale-50"
              enterTo="opacity-100 scale-100"
              leave="duration-100"
              leaveFrom="opacity-50 scale-50"
              leaveTo="opacity-0 scale-0"
            >
              <Dialog.Panel className="w-4/5 bg-white rounded-2xl p-6 flex flex-col text-center">
                <Dialog.Description className="text-black font-normal text-sm">
                  {error}
                </Dialog.Description>
                <Link
                  className="mt-6 mx-auto px-4 py-2 rounded-full bg-gradient text-white text-xs font-medium"
                  to={-2}
                >
                  Back to Dashboard
                </Link>
              </Dialog.Panel>
            </Transition.Child>
          </Transition.Child>
        </Dialog>
      </Transition>

      <div className="mt-6 p-5 rounded-[20px] bg-[#364560] text-white space-y-1.5">
        <h3 className="text-sm font-medium text-secondary">Disclaimer</h3>
        <p className="text-xxs text-justify font-light leading-4 text-white/80">
          For Investigational Use Only. Careplix is not a substitute for the
          clinical judgment of a health care professional. Careplix is intended
          to improve your awareness of general wellness. Careplix does not
          diagnose, treat, mitigate or prevent any disease, symptom, disorder or
          abnormal physical state. Consult with a health care professional or
          emergency services if you believe you may have a medical issue.
        </p>
      </div>
    </section>
  ) : (
    <Navigate to="/vital-scan-instructions" replace />
  );
};

export default VitalsScanInstructions;
